import React, { useCallback } from 'react';
import VideoZoomSlider, { OnZoomChange } from 'components/VideoZoomSlider';
import { useEditSceneModalZoomContext } from './EditSceneModalZoomContext';
import { useSlotZoom } from './state';
import { block } from './utils';

const EditSceneZoomSlider: React.FC = () => {
  const { setZoomSliderRef } = useEditSceneModalZoomContext();

  const {
    currentScale,
    handleZoomChange: handleSlotZoomChange,
    maxScale,
    minScale,
    showSlider,
  } = useSlotZoom();

  const handleZoomChange: OnZoomChange = useCallback(
    ({ zoom }) => {
      handleSlotZoomChange(zoom);
    },
    [handleSlotZoomChange],
  );

  return (
    showSlider && (
      <VideoZoomSlider
        className={block('preview-zoom-slider')}
        min={minScale}
        max={maxScale}
        onZoomChange={handleZoomChange}
        ref={setZoomSliderRef}
        step={0.01}
        zoom={currentScale}
      />
    )
  );
};

export default EditSceneZoomSlider;
